import styled from "styled-components";

export const OrderInfoLabel = styled.p`
  color: #6d6d6d;
  font-size: 12px;
  line-height: 20px;
`;
export const OrderInfoValue = styled.p`
  font-weight: 500;
  font-size: 16px;
  line-height: 30px;
`;
